// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__KpXe6","row":"ProcedureTreatmentSummary_row__3PxN2"};